import {
    inject,
    Injectable
} from '@angular/core';

import {
    HttpClient
} from '@angular/common/http';

import {
    Observable
} from 'rxjs';

import {
    environment
} from '../../../../environments/environment';

import {
    BranchResponse
} from '../models/branch-response';

import {
    CreateBranchRequest
} from '../models/create-branch-request';

import {
    UpdateBranchRequest
} from '../models/update-branch-request';

import {
    UpdateBranchStatusRequest
} from '../models/update-branch-status-request';


@Injectable({
    providedIn: 'root'
})
export class BranchService {

    private readonly http =
        inject(HttpClient);


    private readonly baseUrl =
        environment.restaurantApiUrl;


    /*
     * =========================================================
     * GET BRANCHES
     * =========================================================
     */

    getBranches(
        restaurantId: string
    ): Observable<BranchResponse[]> {

        return this.http.get<
            BranchResponse[]
        >(
            `${this.baseUrl}/api/v1/restaurants/${restaurantId}/branches`
        );
    }


    /*
     * =========================================================
     * CREATE BRANCH
     * =========================================================
     */

    createBranch(
        restaurantId: string,
        request: CreateBranchRequest
    ): Observable<BranchResponse> {

        return this.http.post<
            BranchResponse
        >(
            `${this.baseUrl}/api/v1/restaurants/${restaurantId}/branches`,
            request
        );
    }


    /*
     * =========================================================
     * UPDATE BRANCH
     * =========================================================
     */

    updateBranch(
        restaurantId: string,
        branchId: string,
        request: UpdateBranchRequest
    ): Observable<BranchResponse> {

        return this.http.put<
            BranchResponse
        >(
            `${this.baseUrl}/api/v1/restaurants/${restaurantId}/branches/${branchId}`,
            request
        );
    }


    /*
     * =========================================================
     * UPDATE BRANCH STATUS
     * =========================================================
     */

    updateBranchStatus(
        restaurantId: string,
        branchId: string,
        request: UpdateBranchStatusRequest
    ): Observable<BranchResponse> {

        return this.http.patch<
            BranchResponse
        >(
            `${this.baseUrl}/api/v1/restaurants/${restaurantId}/branches/${branchId}/status`,
            request
        );
    }
}